import { NetworkError } from '@/errors/NetworkError';

/**
 * The API rejected the session and MSAL cannot renew it silently, for example
 * because the 24-hour SPA refresh token expired. Only an interactive sign-in
 * recovers, so callers redirect to login at once and never retry.
 */
export class AuthInteractionRequiredError extends NetworkError {
  constructor() {
    super('Sign-in required', 401);
    this.name = 'AuthInteractionRequiredError';
  }
}

export function isAuthInteractionRequiredError(
  error: unknown
): error is AuthInteractionRequiredError {
  return error instanceof AuthInteractionRequiredError;
}
